module.exports = __webpack_public_path__ + "img/hand-money-white.afa738a1.svg";